import { MediaItem } from '../../components/MediaCarousel';

export type GrowingEnvironment = 'indoor' | 'outdoor';
export type SeedPackageType = 'salad_mix' | 'herb_garden' | 'greens_bag' | 'chefs_choice';
export type SuggestedProduct = 'The Grow Box' | 'The Everything Grow Box';

export const PRODUCT_FEATURES = {
  'The Grow Box': [
    'A box delivered to your door!',
    '10 gallon grow bag',
    'Your selected seed packet',
    'Organic Fertilizer',
    'Self-watering spike',
    'Digitized, zone‑matched planting plan',
    'Onboarding Videos & Tutorials',
    'Tailored care reminders'
  ],
  'The Everything Grow Box': [
    'A box delivered to your door!',
    '10 gallon grow bag',
    'Organic Soil (shipped separately)',
    'Your selected seed packet',
    'Organic Fertilizer',
    'Self-watering spike',
    'Premium growing supplies',
    'Digitized, zone‑matched planting plan',
    'Onboarding Videos & Tutorials',
    'Tailored care reminders',
    'Priority email support'
  ],
} as const;

export const SEED_PACKAGES = {
  salad_mix: {
    emoji: '🥗',
    name: 'Salad Mix',
    description: 'Crisp, quick-growing, great for clipping often.',
    includes: ['Lettuce', 'Arugula', 'Spinach', 'Radish']
  },
  herb_garden: {
    emoji: '🌿',
    name: 'Herb Garden',
    description: 'Fragrant, multi-use herbs to spice up your kitchen all season.',
    includes: ['Parsley', 'Cilantro', 'Dill', 'Basil']
  },
  greens_bag: {
    emoji: '🥬',
    name: 'Greens Bag',
    description: 'Nutrient-dense and cut-and-come-again friendly.',
    includes: ['Kale (dwarf or baby type)', 'Swiss chard', 'Mustard greens', 'Arugula']
  },
  chefs_choice: {
    emoji: '💚',
    name: "Chef's Choice",
    description: 'A flavor-forward mix of greens and herbs for creative cooks.',
    includes: ['Lettuce', 'Arugula', 'Parsley', 'Basil']
  }
} as const;

export const PRODUCT_INFO = {
  'The Grow Box': {
    slug: 'the-grow-box',
    price: 49,
    external_url: 'https://buy.stripe.com/7sYeVcamu93M0cI5z12B20a'
  },
  'The Everything Grow Box': {
    slug: 'the-everything-grow-box',
    price: 79,
    external_url: 'https://buy.stripe.com/7sYcN452a7ZI5x25z12B20b'
  }
} as const;

export const MEDIA_ITEMS: MediaItem[] = [
  {
    type: 'image',
    url: '/Cool Veggie Garden Mock Up.png',
    alt: 'Blooma Grow Box with gardening supplies and fresh vegetables',
    caption: 'Everything you need to start growing'
  },
  {
    type: 'image',
    url: '/Planting.png',
    alt: 'Planting guide and instructions',
    caption: 'Easy-to-follow planting guide'
  },
  {
    type: 'image',
    url: '/Grow Bag Dimensions.png',
    alt: 'Grow bag dimensions and specifications',
    caption: 'Perfect size for your growing space'
  }
];

export interface Testimonial {
  quote: string;
  name: string;
  zone: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    quote: "Such a fun and easy way to grow greens! My kids loved it.",
    name: "Amanda",
    zone: "Zone 6b"
  },
  {
    quote: "It came with everything I needed. My little garden is actually flourishing!",
    name: "Karla",
    zone: "Zone 5a"
  },
  {
    quote: "Perfect for beginners! The instructions are clear and easy to follow.",
    name: "Sarah",
    zone: "Zone 7a"
  },
  {
    quote: "I finally didn't kill a plant.",
    name: "Jessica",
    zone: "Zone 8b"
  },
  {
    quote: "First harvest in 30 days! My kids help water it every day.",
    name: "Mike",
    zone: "Zone 6a"
  },
  {
    quote: "Apartment-friendly and actually works. I was skeptical but now I'm a believer.",
    name: "Rachel",
    zone: "Zone 5b"
  }
];

export interface ProductDetails {
  id: string;
  name: string;
  price: number;
  originalPrice?: number;
  slug: string;
  external_url: string | null;
  description: string;
}
